import React from 'react';
import './NewCollections.css';
import new_collection from '../Assets/new_collections';
import Item from '../Item/Item';

const NewCollections = () => {
    return (
        <div className="new-collections">
            <div className="section-header">
                <h2>Newly Added Medical Products</h2>
                <p className="subtitle">Fresh arrivals for your lab and clinical needs</p>
                <div className="header-divider"></div>
            </div>
            
            <div className='collections-grid'>
                {new_collection.map((item) => (
                    <Item 
                        key={item.id} 
                        id={item.id} 
                        name={item.name} 
                        image={item.image} 
                        new_price={item.new_price} 
                        old_price={item.old_price}
                        category={item.category}
                        isNew={true}
                    />
                ))}
            </div>
            
            <div className="view-more-container">
                <button className="view-more-btn">
                    Browse All New Arrivals
                    <span className="arrow-icon">→</span>
                </button>
            </div>
        </div>
    );
}

export default NewCollections;